import clsxm from "@/lib/clsxm";
import type {FC, ReactNode} from "react";

const GradientButton: FC<{
  className?: string;
  gradient?: string;
  Icon?: ReactNode;
  onClick?: () => void;
  title: string;
}> = ({className, gradient = "bg-linear-(--primary-light-gradient)", Icon, onClick, title}) => {
  return (
    <button onClick={onClick} className={clsxm("group rounded-md p-0.5 hover:scale-[1.01]", gradient, className)}>
      <div className="text-primary-dark-solid group-hover:text-primary-medium-solid flex items-center gap-2.5 rounded-md bg-white px-2 py-0.5 text-sm font-medium">
        {Icon}
        {title}
      </div>
    </button>
  );
};

export default GradientButton;
